import { CHANGE_LOCALE } from '../../actions/locale';
import * as RepositoryState from '../../constants/RepositoryState';
export default function commonStateReducer(state, action) {
    switch (action.type) {
        case CHANGE_LOCALE:
            return RepositoryState.NOT_INITED;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/commonStateReducer.js